import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=55c8ea70&scoped=true"
import script from "./PasswordRequirements.vue?vue&type=script&lang=ts"
export * from "./PasswordRequirements.vue?vue&type=script&lang=ts"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=55c8ea70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c8ea70",
  null
  
)

export default component.exports